// import {useContext} from "react";
// import {ModalContext} from "./ModalProvider";

// const ModalContainer = () => {
//     const {currentModal} = useContext(ModalContext);

//     return(
//         <>
//             {currentModal && (currentModal)}
//         </>
//     );
// }

// export default ModalContainer;


import { useContext } from "react";
import { ModalContext } from "./ModalProvider";

const ModalContainer = () => {
    const { modals } = useContext(ModalContext);

    return (
        <>
            {modals.map((modal, index) => {
                const isTop = index === modals.length - 1;

                return (
                    <div
                        key={index}
                        style={{
                            position: "fixed",
                            inset: 0,
                            zIndex: 1000 + index,
                            display: isTop ? "block" : "none", // 👈 아래는 숨기되 유지
                        }}
                    >
                        {modal}
                    </div>
                );
            })}
        </>
    );
};

export default ModalContainer;
